// extracted by mini-css-extract-plugin
module.exports = {"dashboardFilters":"DashboardFilters_dashboardFilters__3aK1c"};